import React, { createContext } from 'react';

const LAZY = createContext({});
const getProvider = () => {
    return function LazyProvider({ children }) {
        return (
            <LAZY.Provider value={''}>
                {children}
            </LAZY.Provider>
        );
    };
};

export const createLazyProvider = () =>
    React.lazy(() => import('./config.json')
        .then(() => {
            const LazyProvider = getProvider();
            return {
                default: LazyProvider,
            };
        })
    );
